/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgMod = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M4.208 14.928v-3.72l1.536 3.16h.768l1.536-3.208v3.768H9.28V9.112H7.976l-1.824 3.832-1.848-3.832H3v5.816zm8.728.112c.875 0 1.547-.263 2.016-.788s.704-1.27.704-2.236c0-.955-.237-1.696-.712-2.224S13.8 9 12.936 9s-1.533.264-2.008.792-.712 1.27-.712 2.224c0 .965.236 1.71.708 2.236s1.143.788 2.012.788zm0-1.064c-.485 0-.847-.168-1.084-.504s-.356-.821-.356-1.456.119-1.119.356-1.452.599-.5 1.084-.5.847.167 1.084.5.356.817.356 1.452-.119 1.12-.356 1.456-.599.504-1.084.504zm5.608.952c.955 0 1.673-.247 2.156-.74s.724-1.215.724-2.164c0-.96-.243-1.685-.728-2.176-.485-.49-1.203-.736-2.152-.736h-1.952v5.816zm-.016-1.016h-.688v-3.784h.688c.544 0 .947.155 1.208.464s.392.787.392 1.432-.132 1.121-.396 1.428-.665.46-1.204.46z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgMod as Mod };
